export class ConfettiHelper {


    public start(fadeOutDuration: number) {
        const canvas: any = document.getElementById('confetti-canvas');
        const ctx = canvas.getContext('2d');
        const confettiCount = 300;
        const gravity = 0.5;
        const terminalVelocity = 5;
        const drag = 0.075;
        //const fadeOutDuration = 5; // seconds
        const totalDuration = fadeOutDuration * 1000;

        const colors = [
            '#FF0A54', '#FF477E', '#FF7096', '#FF85A1',
            '#FFA3B5', '#FBB1BD', '#FFD6DC', '#FFF2F9',
            '#FDE74C', '#5BC0EB', '#9BC53D', '#E55934',
            '#FA7921', '#FA1E0E', '#2EC4B6', '#011627'
        ];

        let confetti = [];
        let startTime = null;
        let animationFrame;

        function resizeCanvas() {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        }

        function randomRange(min, max) {
            return Math.random() * (max - min) + min;
        }

        function initConfetti() {
            confetti = [];
            for (let i = 0; i < confettiCount; i++) {
                confetti.push({
                    x: randomRange(0, canvas.width),
                    y: randomRange(-canvas.height, 0),
                    dx: randomRange(-2, 2),
                    dy: randomRange(0.5, 3),
                    width: randomRange(5, 10),
                    height: randomRange(8, 15),
                    color: colors[Math.floor(Math.random() * colors.length)],
                    rotation: randomRange(0, 2 * Math.PI),
                    rotationSpeed: randomRange(-0.02, 0.02),
                    alpha: 1
                });
            }
        }

        function drawConfettiPiece(piece) {
            ctx.save();
            ctx.translate(piece.x, piece.y);
            ctx.rotate(piece.rotation);
            ctx.globalAlpha = piece.alpha;
            ctx.fillStyle = piece.color;
            ctx.fillRect(-piece.width / 2, -piece.height / 2, piece.width, piece.height);
            ctx.restore();
        }

        function updateConfetti(elapsed) {
            const fadeFactor = 1 - Math.min(elapsed / totalDuration, 1);

            for (let piece of confetti) {
                piece.dy += gravity;
                piece.dy *= (1 - drag);
                piece.dy = Math.min(piece.dy, terminalVelocity);
                piece.x += piece.dx;
                piece.y += piece.dy;
                piece.rotation += piece.rotationSpeed;
                piece.alpha = fadeFactor;
            }
        }

        function render(timestamp) {
            if (!startTime) startTime = timestamp;
            const elapsed = timestamp - startTime;

            ctx.clearRect(0, 0, canvas.width, canvas.height);
            for (let piece of confetti) {
                drawConfettiPiece(piece);
            }

            updateConfetti(elapsed);

            if (elapsed < totalDuration) {
                animationFrame = requestAnimationFrame(render);
            } else {
                cancelAnimationFrame(animationFrame);
                canvas.remove(); // remove canvas when done
            }
        }

        resizeCanvas();
        window.addEventListener('resize', resizeCanvas);

        canvas.setAttribute('style', `
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    pointer-events: none;
    z-index: 9999;
    display: block;
  `);

        initConfetti();
        requestAnimationFrame(render);
    }


}